module.exports = __webpack_public_path__ + "img/ci-icon.6ab02948.png";